// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"3e941060","226":"56bb4e07","274":"52c65911","383":"504702dd","622":"457979ed","651":"b2291218","694":"499e9f1a","698":"fb6fe356","811":"7b47c277","857":"83fb48e8","882":"06a315c4","884":"93b8ed89"}[chunkId] + ".chunk.js";
};